var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.57 8.186 16.32 1l11.748 7.186-3.022 1.37-8.727-5.02-8.727 5.02-3.023-1.37zm3.023 11.065v-8.326L4 9.1v16.368l12.32-6.902 12.319 6.902V9.098l-3.594 1.826v8.327l-8.727-4.96-8.727 4.96zm-.456 5.59L16.319 31l9.182-6.16-2.567-1.254-6.616 3.992-6.617-3.992-2.566 1.254z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWan);
export default __webpack_public_path__ + "static/media/WAN.526ecd6048e8984d16b9e7fd9985cf96.svg";
export { ForwardRef as ReactComponent };